import { Injectable, NgModule, Optional } from '@angular/core';
import { Actions } from '@ngxs/store';

import { ActivityApiService } from '@hiptraveler/data-access/api';
import { EventAction } from '@hiptraveler/data-access/event';
import { AnalyticsService } from '../analytics.service';

@Injectable({
  providedIn: 'root'
})
export class EventStateService extends AnalyticsService {

  constructor(
    actions$: Actions,
    api: ActivityApiService
  ) {
    
    super(actions$);

    this.observeActionDispatched(EventAction.NavigateToExternalLinkEvent, ({ payload }: EventAction.NavigateToExternalLinkEvent) => api.setUserAction({
      actionType: payload?.actionType,
      objType: payload?.objType
    }, {
      objectId: payload?.objectId,
      actionId: payload?.actionId
    }));

    this.observeActionDispatched(EventAction.ExecuteShareEvent, ({ payload }: EventAction.ExecuteShareEvent) => api.setUserAction({
      actionType: payload?.actionType,
      objType: payload?.objType,
      shareMedium: payload?.shareMedium
    }, {
      actionId: payload?.actionId
    }));
  }

}

@NgModule()
export class EventStateModule {
  constructor(
    @Optional() service: EventStateService
  ) { }
}
